import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { FormGroup, FormBuilder, FormControl, Validators } from '@angular/forms';
import { AuthServiceService } from '../../shareModule/services/auth-service.service';
import { ToastrService } from 'ngx-toastr';
import { Router, ActivatedRoute } from '@angular/router';
import { LocalServiceService } from '../../shareModule/services/local-service.service';

@Component({
  selector: 'app-mass-messaging',
  templateUrl: './mass-messaging.component.html',
  styleUrls: ['./mass-messaging.component.scss']
})
export class MassMessagingComponent implements OnInit {
  @ViewChild('fileInput') mmImageInput: ElementRef;
  profile_pic_url_selected: number = 0;
  profile_pic_url: any;
  profile_pic_path: any;
  selected_profile_pic: File;
  messageForm: FormGroup;
  submitted = false;

  constructor(
    private fb: FormBuilder,
    private auth: AuthServiceService,
    private toastr: ToastrService,
    private router: Router,
    private local: LocalServiceService
  ) { }

  ngOnInit(): void {
    this.messageForm = this.fb.group({
      title: ['', [Validators.required]],
      description: ['', [Validators.required]]
    });
  }

  get messageFormV() {
    return this.messageForm.controls;
  }

  saveMassMessaging() {
    this.submitted = true;

    if (this.messageForm.invalid) {
      return;
    }

    if(this.messageForm.value.title.trim().length == 0) {
      return this.toastr.error('Title cannot be empty.');
    }

    if(this.messageForm.value.description.trim().length == 0) {
      return this.toastr.error('Description cannot be empty.');
    }

    let formData = new FormData();
    formData.append('title', this.messageForm.value.title);
    formData.append('description', this.messageForm.value.description);
    formData.append('image', this.selected_profile_pic);

    this.auth.addMassMessage(formData).subscribe((response: any) => {
      this.toastr.success(response.message);
      this.messageForm.reset();
      this.submitted = false;
      this.profile_pic_url = '';
      this.profile_pic_url_selected = 0;
      this.selected_profile_pic = null;
      this.mmImageInput.nativeElement.value = "";
    }, (e) => {
      if(e.status == 401) {
        this.local.logout();
        this.router.navigate(['/admin'])
      }
      if(e.status == 400) {
        this.toastr.error(e.error.message)
      }
    });
  }

  onImageSelected(files, event: any) {
    if (files.length === 0) {
      return;
    }

    const mimeType = files[0].type;
    if (mimeType.match(/image\/*/) == null) {
      return;
    }

    if (event.target.files && event.target.files[0]) {
      const reader = new FileReader();
      reader.onload = (event: any) => {
        this.profile_pic_url = event.target.result;
        this.profile_pic_url_selected = 1;
      }
      reader.readAsDataURL(event.target.files[0]);
    }

    this.profile_pic_path = files;
    this.selected_profile_pic = <File>files[0];
  }

}
